module.exports = __webpack_public_path__ + "img/it_fuwu.c5e62322.png";